import { cx } from '@linaria/core';
import { useNotifier } from '@provider/notifier';
import { avoidBreakInside } from '@provider/print';
import { PlayIcon, PauseIcon, IconButton } from '@ui/kit';
import { MINUTES_TO_MS, SECONDS_TO_MS } from '@utils/constants';
import { useAudio, useActivityIndicator } from '@utils/react';
import { loader, rightContainer, progressText, wrapper } from './_audio-player.full.js';
import { Progressbar } from './atom.progress-bar.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function AudioPlayer(props) {
  const notifier = useNotifier();
  const audio = useAudio({
    src: props.src,
    autoplay: props.autoplay,
    notifier
  });
  const isLoading = useActivityIndicator(audio.isLoading, {
    delayMs: 1000
  });
  const onClick = () => {
    if (audio.isLoading || audio.isPlaying) {
      audio.pause();
    } else {
      audio.resume();
    }
  };
  const showProgressText = typeof audio.durationMs === "number";
  const icon = (() => {
    if (isLoading.isActive()) {
      return {
        key: "loader",
        element: /*#__PURE__*/jsx("span", {
          className: loader
        })
      };
    }
    if (!audio.isPlaying) {
      return {
        key: "play",
        element: /*#__PURE__*/jsx(PlayIcon, {
          height: 16
        })
      };
    } else {
      return {
        key: "pause",
        element: /*#__PURE__*/jsx(PauseIcon, {
          fill: "currentColor",
          stroke: "none",
          height: 16
        })
      };
    }
  })();
  return /*#__PURE__*/jsxs("div", {
    className: cx(wrapper, props.className),
    ...avoidBreakInside(),
    children: [/*#__PURE__*/jsx(IconButton, {
      icon: icon.element,
      iconKey: icon.key,
      label: audio.isPlaying || audio.isLoading ? "Pause" : "Start afspilning af lydfil",
      onClick: onClick
    }), /*#__PURE__*/jsxs("div", {
      className: rightContainer,
      children: [/*#__PURE__*/jsx(Progressbar, {
        isPlaying: audio.isPlaying || audio.isLoading,
        durationMs: audio.durationMs ?? 0,
        progress: (audio.timeElapsedMs ?? 0) / (audio.durationMs ?? 1),
        resume: audio.resume,
        pause: audio.pause,
        seek: audio.seek
      }), /*#__PURE__*/jsxs("span", {
        className: cx(progressText, showProgressText && "visible"),
        children: [formatTime(audio.timeElapsedMs || 0), " /", " ", formatTime(audio.durationMs)]
      })]
    })]
  });
}
function formatTime(timeInMs) {
  if (typeof timeInMs !== "number") {
    return "";
  }
  const minutes = Math.floor(timeInMs / MINUTES_TO_MS);
  const seconds = Math.round(timeInMs / SECONDS_TO_MS) % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export { AudioPlayer };
//# sourceMappingURL=_audio-player.js.map
